"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "faedo-valtellino": {
    "f6be8b87": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "balzarini-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4a8bb94": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "caprari-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f06cbfe8": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "gaggi-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80eaf187": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "giambonasco": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be0bef71": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "maisi-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9219f273": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "mulino-dei-galli-maggengo-abbandonato": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d363aca7": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "san-bernardo-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cd74d45": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "skipSearch": false
    }],
    "stefen-maggengo": [{
      "hkey": "793312b6",
      "slug": "faedo-valtellino",
      "name": "Faedo Valtellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;